import { useTheme } from './useTheme'

type UseColorResult = 'colorHexLight' | 'colorHexDark'

export const useColor = (): UseColorResult => {
  const theme = useTheme()

  return theme === 'light' ? 'colorHexLight' : 'colorHexDark'
}
